import { QuestionnaireState, QuestionnaireAction } from './types';

export const initialQuestionnaireState: QuestionnaireState = {
  // Data
  questionnaire: null,
  questions: [],
  questionToCategory: new Map(),
  responseWithAnswers: null,

  // Navigation
  currentQuestionIndex: 0,
  isHandlerNavigation: false,

  // UI State
  isLoading: true,
  isWhyWeAskExpanded: false,

  // Session
  hasRestoredSession: false,
  sessionRestoreComplete: false,
  responseId: null,
  isInitializingSession: false,
};

export function questionnaireReducer(
  state: QuestionnaireState,
  action: QuestionnaireAction
): QuestionnaireState {
  switch (action.type) {
    case 'SET_QUESTIONNAIRE':
      return {
        ...state,
        questionnaire: action.payload,
      };

    case 'SET_QUESTIONS':
      return {
        ...state,
        questions: action.payload.questions,
        questionToCategory: action.payload.questionToCategory,
      };

    case 'SET_CURRENT_QUESTION_INDEX':
      return {
        ...state,
        currentQuestionIndex: action.payload,
      };

    case 'SET_LOADING':
      return {
        ...state,
        isLoading: action.payload,
      };

    case 'SET_WHY_WE_ASK_EXPANDED':
      return {
        ...state,
        isWhyWeAskExpanded: action.payload,
      };

    case 'SET_HANDLER_NAVIGATION':
      return {
        ...state,
        isHandlerNavigation: action.payload,
      };


    case 'SET_RESPONSE':
      return {
        ...state,
        responseWithAnswers: action.payload,
      };

    case 'SET_SESSION_RESTORED':
      return {
        ...state,
        hasRestoredSession: action.payload,
        sessionRestoreComplete: action.payload,
      };


    case 'SET_SESSION_STATE':
      return {
        ...state,
        responseId: action.payload.responseId,
      };

    case 'SET_INITIALIZING_SESSION':
      return {
        ...state,
        isInitializingSession: action.payload,
      };


    case 'RESET_STATE':
      return initialQuestionnaireState;

    default:
      return state;
  }
}
